class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
    this.range = null;
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    this.range = this.querySelector('.before-after__range');
    if (!this.range) return;

    this.range.addEventListener('input', this.update);
    this.update();
  }

  disconnectedCallback() {
    if (this.range) this.range.removeEventListener('input', this.update);
  }

  update() {
    const value = Number(this.range.value);
    this.style.setProperty('--before-after-position', `${value}%`);
    this.range.setAttribute('aria-valuetext', `${Math.round(100 - value)}% after image shown`);
  }
}

if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', BeforeAfterSlider);
}
